var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfrmCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 0.833008C4.93744 0.833008 0.833252 4.93717 0.833252 9.99967C0.833252 15.0622 4.93744 19.1663 9.99996 19.1663C15.0625 19.1663 19.1667 15.0622 19.1667 9.99967C19.1667 4.93717 15.0625 0.833008 9.99996 0.833008ZM13.9733 8.44967C14.0465 8.36604 14.1022 8.26862 14.1371 8.16315C14.1721 8.05767 14.1856 7.94627 14.1769 7.83549C14.1681 7.72472 14.1373 7.61681 14.0863 7.51811C14.0352 7.41942 13.965 7.33193 13.8796 7.26079C13.7942 7.18966 13.6955 7.13631 13.5892 7.10389C13.4829 7.07148 13.3712 7.06064 13.2607 7.07203C13.1502 7.08342 13.043 7.1168 12.9456 7.1702C12.8482 7.22361 12.7624 7.29596 12.6933 7.38301L9.10996 11.6822L7.25578 9.82717C7.09861 9.67537 6.88811 9.59138 6.66961 9.59328C6.45111 9.59518 6.2421 9.68282 6.08759 9.83733C5.93309 9.99183 5.84544 10.2008 5.84355 10.4193C5.84165 10.6378 5.92564 10.8483 6.07744 11.0055L8.57745 13.5055C8.65933 13.5873 8.75737 13.6512 8.8653 13.6931C8.97324 13.7349 9.0887 13.7538 9.20435 13.7485C9.31999 13.7433 9.43327 13.714 9.53697 13.6625C9.64066 13.6111 9.7325 13.5386 9.80663 13.4497L13.9733 8.44967Z",
    fill: "#1062D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfrmCategory);
export default __webpack_public_path__ + "static/media/confrmCategory.dda5cf48bdb836dbf5651135b28de977.svg";
export { ForwardRef as ReactComponent };